import { Fragment } from 'react';
import { Breadcrumb, Typography } from 'antd';
import { FormattedMessage } from 'react-intl';
import dynamic from 'next/dynamic';
import Layout from '~/v2/components/layout/Layout';

const Container = dynamic(() => import('../components/other/Container'));
const SectionTitle = dynamic(() => import('~/v2/components/typography/SectionTitle'));

const data = [
  {
    title: 'Delivery Lead Time',
    info: 'We only deliver within East Malaysia. Delivery lead time is 5 working days.',
    title_id: 'app.shipping.1',
    info_id: 'app.shipping.1_info',
  },
  {
    title: 'When will I received my order?',
    info: 'Please allow at least 3-7 working days for your order to arrive. It depend on the given estimated delivery time on your product whether it ship from local warehouse or oversea supplier. If you have any inquiry or concern, please contact us at hello@beccato.com.my or call us at +6012-2199221 from 9am to 11:00pm daily (Malaysia Time Zone (UTC+08:00)), 7 days a week.',
    title_id: 'app.shipping.2',
    info_id: 'app.shipping.2_info',
  },
  {
    title: 'Our Logistic Partners',
    info: 'We will ship your orders via City-Link Express. Our partners are dedicated to deliver your item to you the soonest possible.',
    title_id: 'app.shipping.3',
    info_id: 'app.shipping.3_info',
  },
  {
    title: 'What is the the shipping rates?',
    info: 'We try our best to deliver items to our customers quickly with minimal shipping rates. Currently shipping rates are calculated based on weight, dimensions, origin, and destination. Your shipping fee will be clearly informed during your checkout. Shipping weight is by estimation only. Actual weight may differ.',
    title_id: 'app.shipping.4',
    info_id: 'app.shipping.4_info',
  },
];
function ShippingInformation() {
  return (
    <Layout
      title='Shipping Information'
      head={
        <>
          <link rel='canonical' href='https://coffeepii.com/shipping-information' />
        </>
      }
    >
      <Container>
        <Breadcrumb separator='>'>
          <Breadcrumb.Item>
            <i className='fas fa-home' />
            <FormattedMessage id='app.common.home' defaultMessage='Home' />
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <FormattedMessage id='app.common.shipping_information' defaultMessage='Shipping Information' />
          </Breadcrumb.Item>
        </Breadcrumb>

        <div className='contact'>
          <SectionTitle
            title={<FormattedMessage id='app.common.shipping_information' defaultMessage='Shipping Information' />}
            className='-left'
            hideDecoration={undefined}
            style={undefined}
          />

          {data.map((item) => (
            <Fragment key={item.title_id}>
              <Typography.Title level={5} underline>
                <FormattedMessage id={item.title_id} defaultMessage={item.title} />
              </Typography.Title>
              <Typography.Text>
                <FormattedMessage id={item.info_id} defaultMessage={item.info} />
              </Typography.Text>
            </Fragment>
          ))}
        </div>
      </Container>
    </Layout>
  );
}

export default ShippingInformation;
